import { FC } from 'react';
import styled from '@emotion/styled';
import { Tab, Tabs } from '@mui/material';
import { ScheduleAvailType } from '@/redux/slices/slice_types';
import { FocusTheme } from '@/components/Focus/configs/theme';

type Props = {
  tab: ScheduleAvailType;
  onChange: (tab: ScheduleAvailType) => void;
};

const ScheduleAvailTypeTabs: FC<Props> = ({ tab, onChange }) => (
  <StyledTabs
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
    onChange={(_, v: ScheduleAvailType) => onChange(v)}
    value={tab}
  >
    <StyledTab label="Audio" value="audio" />
    <StyledTab label="Timed Text" value="timedtext" />
    <StyledTab label="Territories" value="territories" />
  </StyledTabs>
);

export default ScheduleAvailTypeTabs;

const StyledTabs = styled(Tabs)`
  margin-bottom: ${({ theme }) => theme.spacing(3)};
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.divider}`};

  .MuiTabs-flexContainer {
    gap: ${({ theme }) => theme.spacing(4)};
    align-items: flex-end;
  }

  .MuiTabs-indicator {
    height: 2px;
    display: flex;
    justify-content: center;
    background-color: transparent;
  }

  .MuiTabs-indicatorSpan {
    width: 100%;
    background-color: ${({ theme }) => theme.palette.primary.main};
  }
`;

const StyledTab = styled(Tab)`
  text-transform: none;
  font-size: 19px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.19px;
  color: ${({ theme }) => (theme as FocusTheme).palette.neutral[40]};
  min-width: unset;
  padding: 0;

  .MuiTouchRipple-root {
    display: none;
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: none;
  }

  &:active {
    background: transparent;
  }

  &.Mui-selected {
    color: ${({ theme }) => (theme as FocusTheme).palette.neutral[0]};
  }
`;
